import { dialogFrame } from "../../ui/primitives.ts";
import { restoreContextualHelp } from "../../ui/contextual-help.ts";

export interface OnboardingControllerCapabilities {
  document: Document;
  icon: (name: string) => string;
  dismiss: () => Promise<void>;
  renderShell: () => Promise<void>;
}

export function createOnboardingController(capabilities: OnboardingControllerCapabilities) {
  function open(): void {
    const dialog = capabilities.document.createElement("dialog");
    dialog.className = "name-dialog onboarding-dialog";
    dialog.setAttribute("aria-label", "The essentials");
    dialog.innerHTML = `<form method="dialog">${dialogFrame("The essentials", "A short guide—everything remains usable without gestures.", `<div class="onboarding-grid">
      <section>${capabilities.icon("folder")}<div><strong>Spaces and collections</strong><p>Spaces separate broad areas; collections organize tasks inside them.</p></div></section>
      <section>${capabilities.icon("plus")}<div><strong>Capture quickly</strong><p>Use New task for structured work and the yellow note button for temporary thoughts.</p></div></section>
      <section>${capabilities.icon("offline")}<div><strong>Offline by default</strong><p>Edits save on this device first and synchronize when a connection is available.</p></div></section>
      <section>${capabilities.icon("users")}<div><strong>Share deliberately</strong><p>A space, collection, or task is private until you explicitly share it.</p></div></section>
      <section>${capabilities.icon("menu")}<div><strong>Mobile gestures</strong><p>Swipe inward away from the system edge for navigation, or use the visible buttons.</p></div></section>
    </div><div class="onboarding-help-reset"><button type="button" class="text-button" data-restore-context-help>Show hidden help again</button><p role="status" data-help-reset-status></p></div><div class="dialog-actions"><button class="button button--primary" value="done">Got it</button></div>`)}</form>`;
    dialog.querySelector("[data-restore-context-help]")!.addEventListener("click", () => {
      restoreContextualHelp(capabilities.document);
      dialog.querySelector("[data-help-reset-status]")!.textContent = "Help restored on this device. It stays collapsed until you open it.";
    });
    dialog.querySelector("form")!.addEventListener("submit", () => { void capabilities.dismiss(); });
    capabilities.document.body.append(dialog);
    dialog.addEventListener("close", () => { dialog.remove(); void capabilities.renderShell(); });
    dialog.showModal();
  }

  return { open };
}
